module.exports = __webpack_public_path__ + "static/media/mic-off.4b9ed2d1.svg";